export default {
  pageTitle: 'Product Commission Management',
  programIntroduction: 'Affiliate Program Introduction',
  storeDefaults: 'Store Defaults',
  storeDefaultsTip: 'Defaults are used for batch enablement and automatic participation. '
    + 'Changes apply to future orders only.',
  commissionRate: 'Commission Rate',
  commissionRatePlaceholder: '1.0 - 20.0',
  defaultVoucher: 'Default Affiliate Voucher Batch',
  voucherPlaceholder: 'Select an Affiliate voucher batch',
  autoEnable: 'Auto-enable New Products',
  saveDefaults: 'Save Defaults',
  clearRate: 'Clear commission rate',
  productList: 'Product Commission Configuration',
  closeFrequencyWarning: 'Closing Affiliate participation for a product 3 or more times within a rolling 30-day period '
    + 'will prevent Affiliate commission from being enabled for that product for 90 days.',
  saleableFilter: 'Product Saleability',
  saleable: 'Saleable',
  notSaleable: 'Not Saleable',
  statusFilter: 'Affiliate Status',
  filterStatusAll: 'All',
  filterStatusClosingBuffer: 'Closing Buffer',
  filterStatusNotEnabled: 'Not Enabled',
  filterStatusReopenBlocked: 'Reopening Blocked',
  productTitle: 'Product Title',
  productTitlePlaceholder: 'Enter product title',
  listingId: 'Listing ID',
  listingIdPlaceholder: 'Enter Listing ID',
  search: 'Search',
  reset: 'Reset',
  batchEnable: 'Enable Selected',
  batchRate: 'Update Commission',
  batchVoucher: 'Replace Affiliate Voucher',
  batchClose: 'Close Selected',
  product: 'Product',
  salePrice: 'Current Price',
  stock: 'Stock',
  fbkStock: 'FBK Stock',
  nonFbkStock: 'Non-FBK Stock',
  voucher: 'Affiliate Voucher Batch',
  estimatedCommission: 'Estimated Commission',
  estimatedCommissionTip: 'This is an estimate based on current product data, not the actual order commission.',
  status: 'Participation Status',
  effectiveCloseCount: 'Close Count',
  updatedTime: 'Updated Time',
  operation: 'Operation',
  enable: 'Enable',
  updateRate: 'Update Rate',
  replaceVoucher: 'Replace Voucher',
  close: 'Close',
  withdrawClose: 'Withdraw Close',
  unavailable: 'Not Saleable',
  noConfig: 'Not Configured',
  statusUnconfigured: 'Not Configured',
  statusDisabled: 'Closed',
  statusEnabled: 'Enabled',
  statusClosingBuffer: 'Closing Buffer',
  statusReopenBlocked: 'Enablement Blocked',
  closingDeadline: 'Closes at: {time}',
  reopenBlockedUntil: 'Can reopen at: {time}',
  configProduct: 'Configure and Enable Product',
  updateProductRate: 'Update Product Commission',
  replaceProductVoucher: 'Replace Product Affiliate Voucher',
  confirm: 'Confirm',
  cancel: 'Cancel',
  selectProducts: 'Select at least one product',
  noAvailableProducts: 'The selected products do not support this operation',
  invalidRate: 'Commission rate must be between 1.0% and 20.0% with at most one decimal place',
  selectVoucher: 'Select an Affiliate voucher batch',
  autoEnableNeedsDefaults: 'Set both a commission rate and default Affiliate voucher '
    + 'before enabling automatic participation',
  saveSuccess: 'Saved successfully',
  operationSuccess: 'Operation completed',
  enableNotApplied: 'Affiliate participation was not enabled. '
    + 'List refreshed; check the current status before retrying.',
  confirmCloseTitle: 'Close Affiliate Participation',
  confirmCloseContent: 'The product enters a 24-hour closing buffer and can be withdrawn during that period. Continue?',
  confirmWithdrawTitle: 'Withdraw Closing Request',
  confirmWithdrawContent: 'The product will continue participating in the Affiliate program. Continue?',
  confirmBatchCloseTitle: 'Close Selected Products',
  confirmBatchCloseContent: 'A closing request will be sent for selected products that support it. '
    + 'The result may be partially successful. Continue?',
  batchOperation: 'Batch Operation',
  batchResult: 'Batch Result',
  batchResultSummary: '{success} succeeded and {failure} failed',
  failureReason: 'Failure Reason',
  message: 'Message',
  versionConflict: 'The configuration changed. The latest data has been loaded; please retry.',
  cpsForbidden: 'Affiliate is not available for this store',
  loadFailed: 'Failed to load data',
  unknownError: 'Operation failed. Please try again later.',
  defaultNotConfigured: 'Store defaults have not been saved',
  createCpsVoucher: 'Manage Affiliate Voucher Batches'
}
